import React, { useCallback, useEffect, useMemo, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import {
  Col,
  DatePicker,
  Divider,
  Form,
  //   Radio,
  Row,
  Select,
  Spin,
  Tag,
  Typography,
  message,
} from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form/Form';
import {
  FinContractResponse,
  getFinContractById,
  getFinModificationByModid,
  getFinModificationValidByCtrid,
  getPopulationToInvoiceByCriteria,
} from 'services/fincontract';
import { useQuery } from 'react-query';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { dateToString, indexBy, toDatePickerDate, unGroup } from 'utils/utils2';
import { getRounding, toCurrency } from 'utils/utils';
import _, { groupBy, isNil, sumBy } from 'lodash';
import { calculatePrefinInterestByContract } from 'services/clientInvoice';
import moment from 'moment';
import {
  AssetRVCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  PricingResponse,
  getprOfferDetailByOfferId,
  prFilteringCriteria,
} from 'services/pricing';
import * as finEngine from 'services/finEngine';
import ParListSelect from 'components/ParListSelect';
import SliderWithInputAndPercentage from 'components/SliderWithInputAndPercentage';
import SliderWithInput from 'components/SliderWithInput';
import { commissionToElement } from 'pages/ProposalV3/PropDetail/commissionToElement';
import { pricingToElement } from 'pages/ProposalV3/PropDetail/pricingToElement';
import { PropElementRequest, PropElementResponse } from 'services/proposal';
import getEnvValue from 'utils/getEnvValue';
import OfferInput from 'pages/ProposalV3/PropDetail/OfferInput';
import Checkbox from 'components/Checkbox';
import {
  findSIByAnyRefOrStatusOrDate,
  SIListResponse,
} from 'services/supplierInvoice';

export type TabColCommentProps = {
  form: FormInstance;
  objectid: number;
  entityReference: string;
};

const TabCTPrefinancingClosure = ({
  objectid,
  form,
  entityReference,
}: TabColCommentProps) => {
  const { Text } = Typography;

  const [mode, setMode] = useState('SIMUL');
  const [withAssets, setWithAssets] = useState(false);

  const [selectedKeys, setSelectedRowKeys] = useState<any[]>([]);

  const [isLoading, setisLoading] = useState('');
  let [includeTotalInterest, setIncludeTotalInterest] =
    useState<boolean>(false);
  let [includeTotalUnpaid, setIncludeTotalUnpaid] = useState<boolean>(false);
  let [flagTolerance, setFlagTolerance] = useState<boolean>(false);

  const { data: modList } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'STARTFIN',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  const { data: contract, isFetching } = useQuery(
    ['getFinContractById', objectid],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data),
    {
      refetchOnWindowFocus: false,
    }
  );

  const {
    data: supplierInvoice,
    isFetching: isFetchingSi,
    refetch,
  } = useQuery(
    ['findSIByAnyRefOrStatusOrDate', entityReference],
    () =>
      findSIByAnyRefOrStatusOrDate({
        clientname: '',
        ctrreference: entityReference ?? '',
        datemax: '',
        datemin: '',
        deliveryreference: '',
        mgid: parseInt(localStorage.getItem('mgid') ?? ''),
        orderreference: '',
        paystatus: '',
        sidocreference: '',
        sireference: '',
        sistatus: '',
        sistatus1: '',
        sistatus2: '',
        suppliername: '',
        tprefclient: '',
        tprefsupplier: '',
      }).then((res) => {
        return res.list || [];
      }),
    { refetchOnMount: false }
  );

  //   const updateState = useCallback(
  //     (values) => {
  //       setState((prev) => ({ ...prev, ...values }));
  //     },
  //     [setState]
  //   );
  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      //   updateState({ isModSelected: false });
      return;
    }

    // updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });
    setisLoading('POFF');
    query
      .then((response) => {
        if (response.code !== '200') {
          return;
        }
        const res = response.data;

        let elemList = res.simulParams
          .find((item) => item.parcode === 'ELEMENTS' && item.partype === 'IN')
          ?.finModSimulParamElements.map((e) => {
            return {
              ...e,
              payOffAmount: e?.outstandingamount - e?.newoutstandingamount,
            };
          });
        let effectDate = res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue;

        let includeTotalInterest1 = res.simulParams.find(
          (item) => item.parcode === 'INCTOTINT' && item.partype === 'IN'
        )?.newvalue;

        let includeTotalUnpaid1 = res.simulParams.find(
          (item) => item.parcode === 'INCTOTUNP' && item.partype === 'IN'
        )?.newvalue;

        let flagTolerance1 = res.simulParams.find(
          (item) => item.parcode === 'FTOLERANCE' && item.partype === 'IN'
        )?.newvalue;

        form?.setFieldsValue({
          mode: 'REAL',
          effectDate: toDatePickerDate(effectDate),

          totalunpaid: Number(
            res.simulParams.find(
              (item) => item.parcode === 'TOTUNP' && item.partype === 'IN'
            )?.newvalue
          ),

          totaloutstanding: res.simulParams.find(
            (item) => item.parcode === 'TOTOUT' && item.partype === 'IN'
          )?.newvalue,

          newRentalAmount: res.simulParams.find(
            (item) => item.parcode === 'NEWRENT' && item.partype === 'IN'
          )?.newvalue,

          cteduration: Number(
            res.simulParams.find(
              (item) => item.parcode === 'DURATION' && item.partype === 'IN'
            )?.newvalue
          ),

          ctegraceperiodduration: Number(
            res.simulParams.find(
              (item) => item.parcode === 'GPDURATION' && item.partype === 'IN'
            )?.newvalue
          ),

          comment: response.data.modcomment,

          ctebillingdate: res.simulParams.find(
            (item) => item.parcode === 'BILDATE' && item.partype === 'IN'
          )?.newvalue,
          ctervamount: res.simulParams.find(
            (item) => item.parcode === 'NEWRV' && item.partype === 'IN'
          )?.newvalue,

          cteperiodicity: res.simulParams.find(
            (item) => item.parcode === 'PERIOD' && item.partype === 'IN'
          )?.newvalue,

          offerid: Number(
            res.simulParams.find(
              (item) => item.parcode === 'OFFER' && item.partype === 'IN'
            )?.newvalue
          ),

          ctenominalrate: res.simulParams.find(
            (item) => item.parcode === 'NEWRATE' && item.partype === 'IN'
          )?.newvalue,

          sifees: res.simulParams.find(
            (item) => item.parcode === 'SIFEES' && item.partype === 'IN'
          )?.newvalue,

          extracost: res.simulParams.find(
            (item) => item.parcode === 'EXTRACOST' && item.partype === 'IN'
          )?.newvalue,

          event_process: res.simulParams.find(
            (item) => item.parcode === 'EVPROCESS' && item.partype === 'IN'
          )?.newvalue,


          mfusedamount: res.simulParams.find(
            (item) => item.parcode === 'MFUSEDAMNT' && item.partype === 'IN'
          )?.newvalue,


          intereststoinvoice: Number(
            res.simulParams.find(
              (item) => item.parcode === 'INTTOINV' && item.partype === 'IN'
            )?.newvalue
          ),
        });

        setSelectedRowKeys(supplierInvoice?.map((si)=>si.siid)??[])

        if (includeTotalInterest1 === 'true') {
          setIncludeTotalInterest(true);
          form.setFieldValue('includeTotalInterest', true);
        } else {
          setIncludeTotalInterest(false);
          form.setFieldValue('includeTotalInterest', false);
        }

        if (includeTotalUnpaid1 === 'true') {
          setIncludeTotalUnpaid(true);
          form.setFieldValue('includeTotalUnpaid', true);
        } else {
          setIncludeTotalUnpaid(false);
          form.setFieldValue('includeTotalUnpaid', false);
        }

        if (flagTolerance1 === 'true') {
          setFlagTolerance(true);
          form.setFieldValue('flagTolerance', true);
        } else {
          setFlagTolerance(false);
          form.setFieldValue('flagTolerance', false);
        }

      })
      .catch(() => {
        setisLoading('');
      });
  };

  const calculatePreFin = (calculationDate?: any) => {
        let date =
      dateToString(calculationDate) ??
      dateToString(form.getFieldValue('effectDate')) ??
      dateToString(moment(new Date(), 'YYYY-MM-DD'));
    setisLoading('INTERSET');
    calculatePrefinInterestByContract({
      ctrid: objectid,
      mode: 'CALCUL',
      calculationDate:
        dateToString(calculationDate) ??
        dateToString(form.getFieldValue('effectDate')) ??
        dateToString(moment(new Date(), 'YYYY-MM-DD')),
      jobid: 0,
    })
      .then((response) => {
        setisLoading('');
        message.success('calculate with success');

        form.setFieldValue(
          'intereststoinvoice',
          _.sumBy(response.list, 'calculatedamount')
        );

        onChangeCheckboxInclude(
          includeTotalInterest,
          includeTotalUnpaid,
          flagTolerance
        );

        if (contract?.conElements[0]) {
          simulate(
            0,
            contract?.conElements[0],
            form.getFieldValue('totaloutstanding')
          );
        }
      })
      .catch(() => {
        setisLoading('');
      });
  };

  const calculateinterestToInvoice = (calculationDate?: any) => {
    let date =
      dateToString(calculationDate) ??
      dateToString(form.getFieldValue('effectDate')) ??
      dateToString(moment(new Date(), 'YYYY-MM-DD'));
    setisLoading('INTERSET');

    if (!isNil(date) && date !== '') {
      getPopulationToInvoiceByCriteria({
        duedate: date,
        ctrid: objectid,
        mgid: Number(localStorage.getItem('mgid')),
        citype: 'RENTAL',
        groupingmode: 'RENTAL',
        flagCalcAtDate: true,
        isSimulation: true,
      })
        .then((response) => {
          setisLoading('');
          let totalInterest = _.sumBy(response.list, 'ctsinterestamount');
          let payOffAmount = form.getFieldValue('payOffAmount');

          form.setFieldsValue({
            intereststoinvoice: totalInterest,
            totaltoinvoice: totalInterest + payOffAmount,
          });
        })
        .catch(() => {
          setisLoading('');
        });
    }
  };

  const calculateFees = (
    pricing?: PricingResponse,
    updatePPOFFees?: boolean
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0]?.conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0]?.ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0].cteduration ?? 0,
          inInvestAmount: contract?.conElements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0]?.assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          if (updatePPOFFees) {
            form?.setFieldsValue({
              payOffFeesAmount: res.installmentamount,
              payOffFormula: pricing?.priid,
            });
          } else {
            form?.setFieldsValue({
              feesAmount: res.installmentamount,
              feesFormula: pricing?.priid,
            });
          }
        }
      });
  };

  const getFilterList = (): prFilteringCriteria => {
    let assetList = form?.getFieldValue('assets');

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'PROPORIGIN',
      critvalue: form?.getFieldValue('ctproporigin') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'DEALRATING',
      critvalue: form?.getFieldValue('ctdealerrating') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'NASSETS',
      critvalue: form?.getFieldValue('assets')?.length ?? '0',
    });

    const duration = contract?.conElements[0]?.cteduration;

    offerCriteriaList.push({
      critcode: 'DURATION',
      critvalue: String(duration) ?? 48,
    });

    const invest = sumBy(form?.getFieldValue('assets'), 'assetnetamount');

    offerCriteriaList.push({
      critcode: 'INVEST',
      critvalue: String(invest) ?? '0',
    });

    //PROPORIGIN

    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });

    assetList?.forEach((a: any) => {
      assetRVCriteriaList.push({
        catalogid: a.catalogid,
        assetid: a.assetid,
        assetsegment: a.assetsegment,
        assetfamily: a.assetfamily,
        assettype: a.assettype,
        assetcategory: a.assetcategory,
        assetmodel: a.assetmodel,
        assetbrand: a.assetbrand,
        assetbrandmodel: a.assetbrandmodel,
        assetnetamount: a.assetnetamount,
        assetfinamount: a.assetfinamount,
        assetvariant: a.assetvariant,
      });

      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer:
        assetList && assetList.length > 0
          ? assetList![0]?.tpidmanufacturer ?? 0
          : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const loadOfferWithnewDuration = async (newDuration: number) => {
    const cteid = form.getFieldValue('selectedElement');
    await getprOfferDetailByOfferId({
      offerid: form?.getFieldValue('offerParams')?.offerid,
      filtersList: getFilterList(),
      duration: newDuration,
    }).then((res) => {
      if (res.data !== null) {
        let indexElement = -1;
        let elements = form.getFieldValue('elements');
        let finElements = form.getFieldValue(['elements', 'FIN']) || [];
        let invest = form.getFieldValue('ctfinancedamount');

        indexElement =
          finElements.findIndex((item: any) => item.cteid === cteid) ?? 0;
        // adjust rate :

        finElements[indexElement].ctenominalrate =
          res.data.ratespreaddefault + res.data.ratevaluedefault;

        //adjust RV
        if (res.data.rvevaluationmode === 'PERC') {
          finElements[indexElement].ctervamount =
            (res.data.rvdefault * invest) / 100;
          finElements[indexElement].helpers.rvmax = res.data.rvmax;
          finElements[indexElement].helpers.rvmin = res.data.rvmin;
          finElements[indexElement].helpers.rvcontextmax =
            res.data.rvcontextmax;
          finElements[indexElement].helpers.rvcontextmin =
            res.data.rvcontextmin;
        } else {
          finElements[indexElement].ctervamount = res.data.rvdefaultamount;
          finElements[indexElement].helpers.rvmax =
            (res.data.rvmax / invest) * 100;
          finElements[indexElement].helpers.rvmin =
            (res.data.rvmin / invest) * 100;
          finElements[indexElement].helpers.rvcontextmax =
            (res.data.rvdefaultamount / invest) * 100;
          finElements[indexElement].helpers.rvcontextmin =
            (res.data.rvdefaultamount / invest) * 100;
        }

        elements = { ...elements, FIN: finElements };

        form.setFieldsValue({ elements: elements });
        ///
        /////
        let commList: Array<PropElementRequest> = [];

        let pricing = {
          ofrid: res.data.offerid,
          ofrtype: 'OFFER',
          ofrlabel: res.data.offerlabel,
          ofrdescription: '',
        };

        let newElements: any[] = [];
        res.data.servicesList?.forEach((item) => {
          if (item.ctetype === 'COMM') {
            commList.push(
              commissionToElement(
                pricing,
                item,
                item.commissionResponse,
                cteid,
                invest
              )
            );
          } else {
            if (item.commissionList?.length !== 0) {
              item.commissionList?.forEach((c) =>
                commList.push(
                  commissionToElement(pricing, item, c, cteid, invest)
                )
              );
            }

            newElements.push(
              pricingToElement(
                pricing,
                item,
                invest,
                0,
                0,
                0,
                item.ctetype === 'FIN' || item.ctetype === 'SPV' ? cteid : 0,
                cteid
              )
            );
          }
        });
        commList.forEach((e) => {
          newElements.push(e);
        });

        const elementsByType = form.getFieldValue('elements') ?? {};

        const oldElements = unGroup(elementsByType).filter(
          (item: any) => item.cteidparent !== cteid
        );

        const finalElemList = oldElements.concat(newElements);

        const {
          FIN = [],
          FINOUT = [],
          SPV = [],
          SERV = [],
          FEES = [],
          COMM = [],
          FINSERV = [],
          SERVOUT = [],
        } = groupBy(finalElemList, 'ctetype');

        let _newElements: any = {
          COMM,
          FEES,
          FIN,
          FINOUT,
          SPV,
          FINSERV,
          SERV,
          SERVOUT,
        };
        form.setFieldsValue({
          elements: _newElements,
        });

        ////
      }
    });
  };

  const reset = () => {
    if (contract) {
      let ct: FinContractResponse = contract;
      const elemFin = contract?.conElements?.find(
        (e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM'
      );

      setWithAssets(contract.assets.length > 0);

      let usedAmount = 0;
      if (contract.assets.length > 0) {
        form.setFieldValue('event_process', 'SUPPSCHEDULE');
        usedAmount = 0;
      } else {
        form.setFieldValue('event_process', 'ELEMENT');
        usedAmount = ct?.mfusedamount;
      }

      let outstandingamount = _.sumBy(
        contract?.conElements?.filter(
          (e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM'
        ),
        'cteinvestamount'
      );

      let schedule = contract?.conElements
        ?.filter((e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM')[0]
        ?.conElemSchedules?.filter((c) => c.ciid !== null);

      let lastinvoicedate = _.maxBy(schedule, 'ctsduedate')?.ctsduedate;
      let lastinvoicamount = _.maxBy(schedule, 'ctsduedate')?.ctstotalamount;

      let totalInv = 0;
      let totalReim = 0;
      contract?.conElements.forEach((e) => {
        if (e.ctestatus === 'TERM') {
          totalReim = totalReim + e.cteinvestamount - e.ctervamount;
        }

        totalInv = totalInv + _.sumBy(e.conElemSchedules, 'ctsrentalamount');
      });

      form?.setFieldsValue({
        event: 'tabCTPrefinancingClosure',
        ctactivationdate: ct?.ctactivationdate,
        mfusedamount: usedAmount,
        ctenddate: ct?.ctenddate,
        ctfinancedamount: ct?.ctfinancedamount,
        lastinvoicedate: lastinvoicedate,
        lastinvoicamount: lastinvoicamount,
        totalreimbursment: totalReim,
        totalinvoicedamount: totalInv,
        outstandingamount: outstandingamount,
        offerid: contract?.offerid,
        intereststoinvoice: 0,
        currcode: contract.currcode,
        ctegraceperiodmethod: contract?.ctegraceperiodmethod,
        ctebillingdate: contract.ctbillingdate,
        ctegraceperiodduration: contract.offer.gpduration ?? 0,
        newDuration: elemFin?.cteduration,
        newRate: elemFin?.ctenominalrate,
        ctervamount: contract.ctervamount ?? 0,
        ctenominalrate:
          contract.offer.ratevaluedefault + contract.offer.ratespreaddefault ??
          0,
        totalunpaid: contract.totalunpaidamount,
        totaloutstanding: outstandingamount,
        cteduration: contract.conElements[0].cteduration ?? 0,
        includeTotalInterest: false,
        includeTotalUnpaid: false,
        effectDate:
          !isNil(lastinvoicedate) && lastinvoicedate !== ''
            ? toDatePickerDate(lastinvoicedate)
            : moment(new Date(), 'YYYY-MM-DD'),
        mode: 'SIMUL',
        comment: '',
        payid: '' as any,
        paymount: 0,
        calcMethod: 'LINEAR',
        prcode: contract.prcode,
        flagmasterfacility: contract.flagmasterfacility,
        mfprcode: contract.mfprcode,
      });

      setIncludeTotalInterest(false);
      setIncludeTotalUnpaid(false);

      // calculatePreFin(lastinvoicedate);

      const elemList = contract?.conElements?.filter(
        (elem: any) =>
          elem.ctecalculationtype === 'PREFIN' && elem.ctestatus !== 'TERM'
      );

      const newElemList = elemList.map((e) => {
        return {
          ...e,
          outstandingamount:
            e?.conElemSchedules[0]?.ctsoutstandingamount ?? e?.cteinvestamount,
          newoutstandingamount:
            e?.conElemSchedules[0]?.ctsoutstandingamount ?? e?.cteinvestamount,
        };
      });

      let newnewOutstanding = 0;
      // newnewOutstanding =   - _.sumBy(newElemList, 'payOffAmount');
      form.setFieldValue(
        'newOutstanding',
        _.sumBy(newElemList, 'newoutstandingamount')
      );

      form.setFieldValue('elemList', newElemList);
      simulate(0, contract?.conElements[0], outstandingamount);
    }
  };

  useEffect(() => {
    reset();
  }, [contract]);

  const getName = useCallback(
    (name: string) => (record: any) => {
      const elemList = form.getFieldValue('elemList');
      const index = indexBy(elemList, 'cteid')[record.cteid];
      return ['elemList', index, name];
    },
    [form]
  );

  // const calculateNewOutstandingAmount = () =>{

  //     let NewOutstandingAmount=0;

  // }

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (selectedRowKeys: any[], selectedRows: SIListResponse[]) => {
      setSelectedRowKeys(selectedRowKeys);

      let listSiAssetAndFees = selectedRows.filter(
        (si) => si.sitype === 'ASSETF' || si.sitype === 'FEES'
      );

      let usedAmount = sumBy(listSiAssetAndFees, 'sinettotal');

      let listSiFees = selectedRows.filter((si) => si.sitype === 'FEES');

      let sifees = sumBy(listSiFees, 'sinettotal');
      form.setFieldValue('sifees', sifees);

      let newExtracost = sifees;

      if (includeTotalInterest) {
        newExtracost += form.getFieldValue('intereststoinvoice');
      }

      if (includeTotalUnpaid) {
        newExtracost += form.getFieldValue('totalunpaid');
      }

   
      let outstandingamount = form.getFieldValue('outstandingamount');

      let totaloutstanding = outstandingamount;

      if (flagTolerance === true) {
        totaloutstanding = form.getFieldValue('mfusedamount');
      }

      if (includeTotalUnpaid === true) {
        totaloutstanding += form.getFieldValue('totalunpaid');
      }

      if (includeTotalInterest) {
        totaloutstanding += form.getFieldValue('intereststoinvoice');
      }


      form.setFieldValue('totaloutstanding', totaloutstanding);

      form.setFieldValue('extracost', newExtracost);
      form.setFieldValue('mfusedamount', usedAmount);
    },
  };

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      //   {
      //     dataIndex: 'flagpayoff',
      //     width: '90px',
      //     render: (val, record) => String(val ?? false),
      //   },
      // {
      //   dataIndex: 'ctecategorylabel',
      //   width: '150px',
      // },

      {
        dataIndex: 'ctedescription',
        width: '200px',
      },
      {
        dataIndex: 'cteinvestamount',
        width: '150px',
        align: 'right',
        render: (val, record) => toCurrency(val, record.currcode),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, mode]
  );

  const columnsSI = useMemo<DataGridColDef<SIListResponse>[]>(
    () => [
      {
        dataIndex: 'sireference',
      },
      {
        dataIndex: 'sitypelabel',
      },

      {
        dataIndex: 'sidocdate',
        render: (e) => moment(e).format('YYYY-MM-DD'),
      },
      { dataIndex: 'sidocreference' },
      { dataIndex: 'suppliername' },
      {
        dataIndex: 'sinettotal',
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'sigrosstotal',
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'sidueamount',
        render: (val, record) => toCurrency(val, record.currcode),
      },

      { dataIndex: 'deliveryreference' },
      {
        comcode: 'sistatuslabel',
        dataIndex: 'sistatus',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refetch]
  );

  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }

      let lastinvoicedate = form?.getFieldValue('lastinvoicedate');

      return (
        moment(lastinvoicedate) != null &&
        d.isBefore(moment(lastinvoicedate)) &&
        !d.isSame(moment(lastinvoicedate), 'day')
      );
    },
    [form?.getFieldValue('lastinvoicedate')]
  );

  const simulate = (
    inCteid: number,
    finElement: PropElementResponse,
    finamount: number
  ) => {
    setisLoading('RENTAL');
    let ctenominalrate = form.getFieldValue('ctenominalrate');
    let finReq: any = {
      inBillingDate:
        form.getFieldValue('ctebillingdate') ?? finElement?.ctebilligdate,
      inCalculationMethod: 'INST',
      inCountingbasis: finElement?.cteratebasis,
      inDeferredMethod: finElement?.ctedeferredinterestmethod,
      inDeferredRate: finElement?.ctedeferredinterestnominalrate,
      inDepositAmount:
        finElement?.ctedepositamount == null ? 0 : finElement?.ctedepositamount,
      inDepositMethod: finElement?.ctedepositinterestmethod,
      inDepositRate:
        finElement?.ctedepositinterestmethod === 'NONE'
          ? 0
          : finElement?.ctedepositnominalrate == null
          ? 0
          : finElement?.ctedepositnominalrate,
      inDuration: form.getFieldValue('cteduration') ?? finElement?.cteduration,
      inFinancedAmount: finamount,
      inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
      inFirstPayment: finElement?.ctefirstpayment,
      inGracePeriodDuration:
        finElement?.ctegraceperiodduration == null
          ? 0
          : finElement?.ctegraceperiodduration,
      inGracePeriodMethod: finElement?.ctegraceperiodmethod,
      inInstallmentAmount: finElement?.cteinstallmentamount,
      inInterestMethod: finElement?.cteinterestmethod,
      inPartAmount:
        finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
      inPartMethod: finElement?.ctepartmethod
        ? finElement?.ctepartmethod
        : 'NONE',
      inPartNbDays:
        finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
      inPartRate: finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
      inPeriodicity: finElement?.cteperiodicity,
      inPeriodicityUnit: finElement?.cteunit,
      inRatePeriodicity: Number(finElement?.cterateperiodicity),
      inRateType: finElement?.cteratetype,
      inRateValue:
        ctenominalrate ?? finElement?.ctenominalrate == null
          ? 0
          : finElement?.ctenominalrate,
      inResidualValue: finElement?.ctervamount,
      inRoundingAmount: getRounding(finElement?.currcode),
      inRoundingRate: 9,
      inStartDate: dateToString(finElement?.ctestartdate),
      inTaxcode: finElement?.taxcode,
      inTaxrate: finElement?.taxrate,
      inTaxtype: finElement?.taxtype,
      inTerm: finElement?.ctepaymentterm,
      inUpFrontAmount:
        finElement?.cteupfrontamount == null ? 0 : finElement?.cteupfrontamount,
    };

    finReq.inRateValue = ctenominalrate;

    finEngine
      .calculate({
        finReq: finReq,
      })
      .then((res) => {
        setisLoading('');
        message.success('calculate with success');

        if (res) {
          let rental =
            res.paymentSchedule.find((s: any) => s.ctstype === 'RENTAL')
              ?.ctsrentalamount ?? 0;

          form.setFieldValue('newRentalAmount', rental);
        }
      })
      .catch((err) => {
        setisLoading('');
      });
  };

  const onChangeCheckboxInclude = (
    includeTotalInterest: boolean,
    includeTotalUnpaid: boolean,
    _flogTolerance: boolean
  ) => {
    let outstandingamount = form.getFieldValue('outstandingamount');

    let totaloutstanding = outstandingamount;

    if (withAssets) {
      if (_flogTolerance === true) {
        totaloutstanding = form.getFieldValue('mfusedamount');
      }

      if (includeTotalUnpaid === true) {
        totaloutstanding += form.getFieldValue('totalunpaid');
      }

      if (includeTotalInterest) {
        totaloutstanding += form.getFieldValue('intereststoinvoice');
      }

      let newExtracost = form.getFieldValue('sifees') ?? 0;

      if (includeTotalInterest) {
        newExtracost += form.getFieldValue('intereststoinvoice');
      }

      if (includeTotalUnpaid) {
        newExtracost += form.getFieldValue('totalunpaid');
      }

      form.setFieldValue('extracost', newExtracost);
    } else {
      if (includeTotalInterest) {
        totaloutstanding =
          totaloutstanding + form.getFieldValue('intereststoinvoice');
      }

      if (includeTotalUnpaid) {
        totaloutstanding = totaloutstanding + form.getFieldValue('totalunpaid');
      }
    }


    form.setFieldValue('totaloutstanding', totaloutstanding);

    if (contract?.conElements[0]) {
      simulate(0, contract?.conElements[0], totaloutstanding);
    }
  };

  return (
    <DF.Provider pagcode="ctprefinancingclosure">
      <Spin spinning={isFetching}>
        <UtinaCard comcode="CTPrefinancingClosure" level={5}>
          <Row gutter={10}>
            <FormInput
              col
              md={5}
              name="mode"
              rules={[{ required: true }]}
              initialValue={mode}
            >
              <div className="radio-group">
                <span
                  className={
                    mode === 'SIMUL'
                      ? 'radio-button radio-button-checked'
                      : 'radio-button'
                  }
                  onClick={() => {
                    setMode('SIMUL');
                    form.setFieldsValue({ modid: undefined, mode: 'SIMUL' });
                    reset();
                  }}
                >
                  SIMUL
                </span>
                <span
                  className={
                    mode === 'REAL'
                      ? 'radio-button radio-button-checked'
                      : 'radio-button'
                  }
                  onClick={() => {
                    reset();
                    setMode('REAL');
                    form.setFieldValue('mode', 'REAL');
                  }}
                >
                  REAL
                </span>
              </div>
            </FormInput>

            {/* <Col md={5}>
                <div className="radio-group">
                  <span
                    className={
                      mode === 'SIMUL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('SIMUL');
                    }}
                  >
                    SIMUL
                  </span>
                  <span
                    className={
                      mode === 'REAL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('REAL');
                    }}
                  >
                    REAL
                  </span>
                </div>
              </Col> */}

            {mode === 'REAL' && (
              <FormInput
                col
                md={8}
                name="modid"
                labelAlign="left"
                rules={[{ required: mode === 'REAL' }]}
              >
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  onSelect={handleFinModSelect}
                  onClear={() => {
                    reset();
                    setMode('SIMUL');
                  }}
                >
                  {modList?.map((e: any, index: number) => (
                    <Select.Option key={index} value={e.modid}>
                      {e.ctreference + ' - ' + e.modid + ' - ' + e.modcomment}
                    </Select.Option>
                  ))}
                </Select>
              </FormInput>
            )}
          </Row>
          <Divider />
          <Row gutter={10}>
            <Col
              span={6}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Tag color="magenta" style={{ borderRadius: 5 }}>
                <FormInput
                  name="effectDate"
                  noMargin
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    disabled={mode === 'REAL'}
                    size="middle"
                    onChange={(e) => calculatePreFin(e)}
                    // disabledDate={disableDaysBeforeToday}
                  />
                </FormInput>
              </Tag>
            </Col>
            {/* <FormInput col md={6} name="ctactivationdate">
              <Value />
            </FormInput>
            <FormInput col md={6} name="ctenddate">
              <Value />
            </FormInput> */}

            <Col md={6}>
              <FormInput name="ctfinancedamount" comcode="approuvedAmount">
                <Value formatter={(val) => toCurrency(val)} />
              </FormInput>
            </Col>
            <Col md={6}>
              <Tag color="green">
                <FormInput
                  name="mfusedamount"
                  comcode="usedAmount"
                  wrapperCol={{ span: 4 }}
                >
                  <Value formatter={(val) => toCurrency(val)} />
                </FormInput>
              </Tag>
            </Col>

            <FormInput col md={6} name="flagTolerance" noStyle shouldUpdate>
              <Checkbox
                checked={flagTolerance}
                comcode="flagTolerance"
                onChange={(e) => {
                  if (mode !== 'REAL') {
                    form.setFieldValue('flagTolerance', e.target.checked);
                    setFlagTolerance(e.target.checked);
                    onChangeCheckboxInclude(
                      includeTotalInterest,
                      includeTotalUnpaid,
                      e.target.checked
                    );
                  }
                }}
              />
            </FormInput>

            <FormInput col md={6} name="totalinvoicedamount">
              <Value formatter={(val) => toCurrency(val)} />
            </FormInput>

            <FormInput col md={6} name="lastinvoicedate">
              <Value />
            </FormInput>

            <Col md={6}>
              <FormInput name="outstandingamount">
                <Value formatter={(val) => toCurrency(val)} />
              </FormInput>
            </Col>

            <FormInput col md={6} name="lastinvoicamount">
              <Value formatter={(val) => toCurrency(val)} />
            </FormInput>

            <FormInput col md={6} name="event_process">
              <Value />
            </FormInput>

            <FormInput col md={6} name="sifees">
              <Value formatter={(val) => toCurrency(val)} />
            </FormInput>

            <FormInput col md={6} name="extracost">
              <Value formatter={(val) => toCurrency(val)} />
            </FormInput>
          </Row>

          <Row gutter={10}>
            <Col span={24}>
              {withAssets ? (
                <DataGrid
                  columns={columnsSI}
                  titleComcode="supplierlist"
                  dataSource={supplierInvoice}
                  componentName="supplierInvoice_list"
                  isLoading={isFetching}
                  rowKey={(record) => record.siid}
                  pagination={false}
                  hideExtraAction
                  hideFilters
                  rowSelection={rowSelection}
                />
              ) : (
                <Form.Item noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    return (
                      <DataGrid
                        scroll={{ x: 1000, y: 900 }}
                        columns={columns}
                        rowKey={(element, index) => element.cteid}
                        dataSource={getFieldValue('elemList')}
                        pagination={false}
                        isLoading={isFetching}
                      />
                    );
                  }}
                </Form.Item>
              )}
            </Col>
            {/* <Col
              span={6}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Tag color="white" style={{ marginTop: 10, borderRadius: 5 }}>
                <FormInput
                  name="payOffAmount"
                  noMargin
                  rules={[{ required: true }]}
                >
                  <InputCurrency
                    currcode={form.getFieldValue('currcode')}
                    max={form.getFieldValue('outstandingamount')}
                    onChange={(e) => {
                      setisLoading('POFF');
                      onChangepayOffAmount(e);
                      //   form.setFieldValue('elemList', rows);
                    }}
                    disabled={mode === 'REAL'}
                    size="middle"
                  />
                </FormInput>
              </Tag>

              <Tag color="white" style={{ marginTop: 10, borderRadius: 5 }}>
                <Spin spinning={isLoading === 'POFF'} tip="Calculation...">
                  <FormInput name="newOutstanding" noMargin>
                    <Value formatter={(val) => toCurrency(val)} />
                  </FormInput>
                </Spin>
              </Tag>
             
            </Col> */}
          </Row>

          <Row gutter={20} style={{ marginTop: 15 }}>
            <Col md={10}>
              <Spin spinning={isLoading === 'INTERSET'} tip="Calculation...">
                <FormInput name="intereststoinvoice">
                  <Value formatter={(val) => toCurrency(val)} />
                </FormInput>
              </Spin>

              <FormInput col md={24} name="totalunpaid">
                <Value formatter={(val) => toCurrency(val)} />
              </FormInput>
              <FormInput col md={24} name="totaloutstanding">
                <Text type="danger">
                  {toCurrency(form.getFieldValue('totaloutstanding'))}
                </Text>
              </FormInput>

              <FormInput col md={24} name="offerid" shouldUpdate>
                <OfferInput
                  disabled={mode === 'REAL'}
                  params={{
                    prcode: form.getFieldValue('flagmasterfacility')
                      ? form.getFieldValue('mfprcode')
                      : form.getFieldValue('prcode')
                      ? form.getFieldValue('prcode')
                      : '',
                    filtersList: getFilterList(),
                    filters: '',
                    finamount: form.getFieldValue('ctfinancedamount'),
                    duration: form.getFieldValue('cteduration'),
                    searchMode: 'PRCODE',
                  }}
                  onChange={(e) => {}}
                />
              </FormInput>
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => (
                  <FormInput
                    col
                    xs={24}
                    comcode="ctegraceperiodduration"
                    name="ctegraceperiodduration"
                  >
                    <SliderWithInput
                      min={0}
                      max={contract?.offer.gpduration ?? 0}
                      precision={0}
                      // onChange={() => debouncedCalculateNew('', 'INST')}
                      disabled={mode === 'REAL'}
                    />
                  </FormInput>
                )}
              </Form.Item>

              <FormInput col md={24} name="ctegraceperiodmethod">
                <ParListSelect parcode="GPMETHOD" disabled={mode === 'REAL'} />
              </FormInput>

              <FormInput col md={24} name="ctebillingdate">
                <ParListSelect parcode="BILLDATE" disabled={mode === 'REAL'} />
              </FormInput>

              <FormInput col md={24} name="ctervamount">
                <SliderWithInputAndPercentage
                  currcode={form.getFieldValue('currcode')}
                  step={1}
                  precisionAmount={2}
                  precisionCoef={5}
                  max={contract?.offer?.rvmax ?? 0}
                  min={contract?.offer?.rvmin ?? 0}
                  basis={0} // onChange={() => debouncedCalculateNew('')}
                  disabled={mode === 'REAL'}
                />
              </FormInput>
            </Col>
            <Col md={10}>
              <Col md={24}>
                <Form.Item name="includeTotalInterest" noStyle shouldUpdate>
                  <Checkbox
                    checked={includeTotalInterest}
                    comcode="includeTotalInterest"
                    onChange={(e) => {
                      if (mode !== 'REAL') {
                        form.setFieldValue(
                          'includeTotalInterest',
                          e.target.checked
                        );
                        setIncludeTotalInterest(e.target.checked);
                        onChangeCheckboxInclude(
                          e.target.checked,
                          includeTotalUnpaid,
                          flagTolerance
                        );
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col md={24} style={{ marginTop: 15, marginBottom: 20 }}>
                <Form.Item name="includeTotalUnpaid" noStyle shouldUpdate>
                  <Checkbox
                    checked={includeTotalUnpaid}
                    comcode="includeTotalUnpaid"
                    onChange={(e) => {
                      if (mode !== 'REAL') {
                        form.setFieldValue(
                          'includeTotalUnpaid',
                          e.target.checked
                        );
                        setIncludeTotalUnpaid(e.target.checked);
                        onChangeCheckboxInclude(
                          includeTotalInterest,
                          e.target.checked,
                          flagTolerance
                        );
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <FormInput col md={24} name="calcMethod">
                <ParListSelect parcode="CALMETHOD" disabled value="LINEAR" />
              </FormInput>

              <Form.Item shouldUpdate={() => true} noStyle>
                {({ getFieldValue }) => (
                  <FormInput col md={24} name="cteduration">
                    <SliderWithInput
                      max={contract?.offer.durationmax ?? 0}
                      min={contract?.offer.durationmin ?? 0}
                      precision={0}
                      onChange={(e) => loadOfferWithnewDuration(Number(e) ?? 0)}
                      defaultValue={contract?.offer.durationdefault}
                      disabled={mode === 'REAL'}
                    />
                  </FormInput>
                )}
              </Form.Item>

              <FormInput col md={24} name="cteperiodicity">
                <ParListSelect
                  parcode="PERIOD"
                  // parvalueparent={getFieldValue('"cteperiodicity"')}
                  disabled={mode === 'REAL'}
                />
              </FormInput>

              <FormInput col md={24} name="ctenominalrate">
                <SliderWithInput
                  step={0.001}
                  precision={5}
                  widthInput={5}
                  max={
                    contract?.offer.ratevaluedefault != null
                      ? contract?.offer.ratevaluedefault +
                        contract?.offer.ratespreadmax
                      : 30
                  }
                  min={
                    contract?.offer.ratevaluedefault != null
                      ? contract?.offer.ratevaluedefault +
                        contract?.offer.ratespreadmin
                      : 0
                  }
                  disabled={mode === 'REAL'}
                  onChange={() => {
                    if (contract?.conElements[0]) {
                      simulate(
                        0,
                        contract?.conElements[0],
                        form.getFieldValue('totaloutstanding')
                      );
                    }
                  }}
                />
              </FormInput>

              <Spin spinning={isLoading === 'RENTAL'} tip="Calculation...">
                <FormInput col md={24} name="newRentalAmount">
                  <Text type="danger">
                    {toCurrency(form.getFieldValue('newRentalAmount'))}
                  </Text>
                </FormInput>
              </Spin>
            </Col>
          </Row>
        </UtinaCard>
      </Spin>
    </DF.Provider>
  );
};
export default TabCTPrefinancingClosure;
